import React from 'react';
import { I18n } from '@aws-amplify/core';

import type { BeraReportV2StepKeyRow } from '@/types/Bera';

import { FactorCell } from './FactorCell';
import { toJobElement } from './utils';
import { Cell, CellHeader, CellValue, RpnHeader, RpnValue } from './styles';

interface DetailCellsProps {
	stepKey: BeraReportV2StepKeyRow;
}

export function DetailCells({ stepKey }: Readonly<DetailCellsProps>): JSX.Element {
	const jobElement = toJobElement(stepKey.jobElement);

	return (
		<>
			<FactorCell label={I18n.get('Stress level')} factor={stepKey.stressLevel} separator={false} />
			<FactorCell label={I18n.get('Frequency')} factor={stepKey.frequency} separator />
			<FactorCell label={I18n.get('Total task duration')} factor={stepKey.totalTaskDuration} separator />
			<Cell separator>
				<CellHeader>{I18n.get('Job element')}</CellHeader>
				<CellValue>{jobElement}</CellValue>
			</Cell>
			<Cell separator>
				<RpnHeader>{I18n.get('Task RPN')}</RpnHeader>
				<RpnValue>{stepKey.taskRpn}</RpnValue>
			</Cell>
		</>
	);
}
